import { Correctness } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

export const CORRECT_TEXT = translate('Correct');
export const INCORRECT_TEXT = translate('Incorrect');
export const EDIT_CORRECT_TEXT = translate('Edited to correct');
export const EDIT_PARTIAL_TEXT = translate('Edited to partial mark');
export const EDIT_INCORRECT_TEXT = translate('Edited to incorrect');

/**
 * Returns the (untranslated) label to display next to the Correctness
 * control based on the state of the response.
 */
export function getCorrectnessLabel({
  formCorrectness,
  responseCorrectness,
}: {
  formCorrectness: Correctness;
  responseCorrectness: Correctness;
}) {
  if (formCorrectness === responseCorrectness) {
    switch (formCorrectness) {
      case Correctness.Correct: {
        return CORRECT_TEXT;
      }
      case Correctness.Incorrect: {
        return INCORRECT_TEXT;
      }
      default: {
        console.error('unhandled correctness label');
        console.error(
          `formCorrectness: ${formCorrectness} responseCorrectness: ${responseCorrectness}`
        );
        return '';
      }
    }
  }

  // Match the correctness override to the appropriate string
  switch (formCorrectness) {
    case Correctness.Correct:
      return EDIT_CORRECT_TEXT;
    case Correctness.Partial:
      return EDIT_PARTIAL_TEXT;
    case Correctness.Incorrect:
      return EDIT_INCORRECT_TEXT;
    default:
      console.error('unhandled correctness label');
      console.error(
        `formCorrectness: ${formCorrectness} responseCorrectness: ${responseCorrectness}`
      );
      return '';
  }
}
